import { render, staticRenderFns } from "./TiozaoSupport.vue?vue&type=template&id=e90daa66&"
import script from "./TiozaoSupport.vue?vue&type=script&lang=js&"
export * from "./TiozaoSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports